import React from "react";
import { Link } from "react-router-dom";
import "./member-dashboard/MemberDashboard.css";

const LuminaryDashboard = () => {
  return (
    <div className="member-dashboard">
      <div className="member-dashboard__content">
        <section className="member-dashboard__hero">
          <p className="member-dashboard__eyebrow">Luminary Portal</p>
          <h1>Welcome to your Luminary dashboard</h1>
          <p className="member-dashboard__subtitle">
            Your account is ready. We’ll keep this space updated as Luminary tools
            continue to expand.
          </p>
          <div className="member-dashboard__hero-actions">
            <Link to="/change-password" className="member-dashboard__primary-action">
              Set or update password
            </Link>
            <Link to="/profile" className="member-dashboard__secondary-action">
              Review profile
            </Link>
          </div>
        </section>

        <section className="member-dashboard__panels">
          <article className="member-dashboard__panel">
            <h2>Getting started</h2>
            <p>
              Your Luminary login is active. Use the links above to confirm your
              profile details and keep your credentials current.
            </p>
          </article>

          <article className="member-dashboard__panel">
            <h2>Need something right away?</h2>
            <p>
              If you need schedule details, studio support, or account updates,
              please reach out to the Diviti Adora team and we’ll get you what you
              need quickly.
            </p>
          </article>
        </section>
      </div>
    </div>
  );
};

export default LuminaryDashboard;
